"use client";

import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuLink } from "@/components/ui/navigation-menu";
import { motion } from "framer-motion";
import { MenuProvider } from "@/integrations/wordpress/WordPressMenuProvider";
const sections = [{
  label: "Hero",
  id: "#hero"
}, {
  label: "AI Tools",
  id: "#ai-tools"
}, {
  label: "Benefits",
  id: "#benefits"
}, {
  label: "FAQ",
  id: "#faq"
}];
export default function Hero() {
  return <section data-section-id="1400" id="hero" className="dark bg-background text-foreground min-h-screen relative overflow-hidden">
      <div className="absolute top-6 left-6 z-50">
        <MenuProvider menu_id="167">
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="bg-transparent hover:bg-white/10 text-white">
                  Menu
                </NavigationMenuTrigger>
                <NavigationMenuContent>
                  <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} className="w-48 p-2 bg-background border border-border rounded-lg shadow-lg">
                    {sections.map(item => <NavigationMenuLink key={item.id} href={item.id} className="block px-4 py-2 text-sm hover:bg-accent rounded-md">
                        {item.label}
                      </NavigationMenuLink>)}
                  </motion.div>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </MenuProvider>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-screen">
        <div className="lg:col-span-9 relative flex items-center justify-center lg:p-12 p-6">
          <div className="relative w-full lg:aspect-[4/5] aspect-[3/4] max-h-screen rounded-lg" style={{
          boxShadow: "0 0 0 12px transparent, 0 0 0 13px hsl(221 83% 53% / 0.3)"
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_hero_shield.webp" alt="Digital shield protecting global network connections" loading="eager" decoding="async" className="w-full h-full object-cover rounded-lg" />
          </div>

          <div className="hidden lg:block absolute bottom-8 left-8 font-mono text-[11px] tracking-[0.18em] uppercase text-muted-foreground">
            SECURE. PRIVATE. GLOBAL. — VPNGENIX
          </div>
        </div>

        <div className="lg:col-span-3 flex flex-col justify-center lg:px-[5vw] px-6 lg:py-16 py-12 relative">
          <div className="flex items-center gap-4 mb-12">
            <span className="font-mono text-[12px] tracking-[0.22em] uppercase" style={{
            color: "hsl(22 100% 50%)"
          }}>
              § COMMAND — 01
            </span>
            <span className="h-px w-10 hidden lg:block" style={{
            backgroundColor: "hsl(22 100% 50%)"
          }} />
          </div>

          <h1 className="font-default font-bold text-foreground" style={{
          fontSize: "clamp(3.5rem, 8.2vw, 8.75rem)",
          letterSpacing: "-0.025em",
          lineHeight: "0.95"
        }}>
            <span className="block">Digital</span>
            <span className="block">Sovereignty</span>
            <span className="block">
              in{" "}
              <span className="italic" style={{
              color: "hsl(22 100% 50%)"
            }}>
                control.
              </span>
            </span>
          </h1>

          <div className="flex items-center mt-12 mb-8">
            <span className="h-px w-[120px] block" style={{
            backgroundColor: "hsl(22 100% 50%)"
          }} />
            <span className="ml-2 inline-block w-1.5 h-1.5 rounded-lg" style={{
            backgroundColor: "hsl(22 100% 50%)"
          }} aria-hidden="true" />
          </div>

          <p className="font-default text-muted-foreground max-w-md" style={{
          fontSize: "clamp(0.9375rem, 1.05vw, 1.0625rem)",
          lineHeight: "1.65",
          letterSpacing: "0.005em"
        }}>
            Military-grade encryption for your home and office. Secure your digital footprint with VPNGENIX.
          </p>

          <div className="mt-16">
            <Link to="/VpnGenixPage" className="inline-flex items-center gap-2 font-default text-[15px] tracking-[0.005em] underline underline-offset-[6px] decoration-1 hover:decoration-2 transition-all duration-200" style={{
            color: "hsl(22 100% 50%)"
          }}>
              Start your protection →
            </Link>
          </div>

          <div className="lg:hidden mt-16 font-mono text-[11px] tracking-[0.18em] uppercase text-muted-foreground">
            SECURE. PRIVATE. GLOBAL. — VPNGENIX
          </div>
        </div>
      </div>
    </section>;
}